export default __webpack_public_path__ + "static/WORTHIT_BLUE-5990fd29a2399b0e1212c4241aea5864.png";